import { getAutoOrderPayConfig } from "@/utils/autoOrderPayConfig";
import { runAutoOrderPayScan } from "@/services/autoOrderPayRunner";

const listeners = new Set();

export const autoOrderPayRuntime = {
    active: false,
    scanning: false,
    lastScanAt: 0,
    lastScanned: 0,
    lastPaid: 0,
    lastMessage: ""
};

function emit() {
    const snap = { ...autoOrderPayRuntime };
    listeners.forEach((fn) => {
        try {
            fn(snap);
        }
        catch (e) {
            console.warn("[autoOrderPay] listener error", e);
        }
    });
}

export function subscribeAutoOrderPayRuntime(fn) {
    listeners.add(fn);
    fn({ ...autoOrderPayRuntime });
    return () => listeners.delete(fn);
}

export function startAutoOrderPayScheduler() {
    let tid = null;
    let scanning = false;

    const schedule = (delayMs) => {
        if (tid)
            clearTimeout(tid);
        tid = setTimeout(tick, delayMs);
    };

    const tick = async () => {
        const cfg = getAutoOrderPayConfig();
        autoOrderPayRuntime.active = cfg.enabled;
        if (!cfg.enabled) {
            autoOrderPayRuntime.scanning = false;
            emit();
            schedule(3000);
            return;
        }

        if (!scanning) {
            scanning = true;
            autoOrderPayRuntime.scanning = true;
            emit();
            try {
                const res = await runAutoOrderPayScan();
                autoOrderPayRuntime.lastScanAt = Date.now();
                autoOrderPayRuntime.lastScanned = res.scanned ?? 0;
                autoOrderPayRuntime.lastPaid = res.paid ?? 0;
                autoOrderPayRuntime.lastMessage = res.message || "";
            }
            catch (e) {
                autoOrderPayRuntime.lastScanAt = Date.now();
                autoOrderPayRuntime.lastMessage = e?.message || "扫描异常";
            }
            finally {
                scanning = false;
                autoOrderPayRuntime.scanning = false;
                emit();
            }
        }

        const intervalSec = Math.max(1, Number(getAutoOrderPayConfig().scanIntervalSec) || 5);
        schedule(intervalSec * 1000);
    };

    const onConfig = () => schedule(50);
    const onVis = () => {
        if (document.visibilityState === "visible" && getAutoOrderPayConfig().enabled)
            schedule(50);
    };

    window.addEventListener("auto-order-pay-config-change", onConfig);
    document.addEventListener("visibilitychange", onVis);
    tick();

    return () => {
        window.removeEventListener("auto-order-pay-config-change", onConfig);
        document.removeEventListener("visibilitychange", onVis);
        if (tid)
            clearTimeout(tid);
        tid = null;
        autoOrderPayRuntime.active = false;
        autoOrderPayRuntime.scanning = false;
        emit();
    };
}
